import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import {
  formatUserMessageText,
  getServiceOrderId,
  isOrderEditable,
  getOrderMutationBlockedMessage,
  OrderService,
  resolveOrderGraphqlUserMessage,
  shouldRefreshAfterOrderError
} from 'src/entities/order';

export interface ReservationNumberDialogData {
  orderId?: string | null;
  service?: {
    order?: {
      orderId?: string | null;
      orderStatus?: string | null;
      reservationNumber?: string | null;
    };
  };
  reservationNumber?: string | null;
}

export interface ReservationNumberDialogResult {
  success: boolean;
  shouldRefresh?: boolean;
  order?: any;
  orderNumber?: string | number | null;
}

type ViewState = 'form' | 'error';

@Component({
  selector: 'app-dialog-num-reserva',
  templateUrl: './dialog-num-reserva.component.html',
  styleUrls: ['./dialog-num-reserva.component.css']
})
export class DialogNumReservaComponent implements OnInit {
  state: ViewState = 'form';
  errorTitle: string | null = null;
  errorMessage: string | null = null;

  codigoControl = new FormControl('', [
    Validators.pattern(/^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ0-9°!"#$%&/()=¿?¡!/*\-+.]*$/)
  ]);
  message = 'Si no tiene código de reserva, dejar en blanco';
  loader = false;

  private readonly orderId: string | null;

  constructor(
    public dialogRef: MatDialogRef<
      DialogNumReservaComponent,
      ReservationNumberDialogResult
    >,
    @Inject(MAT_DIALOG_DATA) public data: ReservationNumberDialogData,
    private readonly orderService: OrderService,
    private readonly toastr: ToastrService
  ) {
    this.orderId =
      data.orderId ?? getServiceOrderId(data.service ?? null) ?? null;
  }

  ngOnInit(): void {
    const currentNumber =
      this.data.service?.order?.reservationNumber ?? this.data.reservationNumber;
    if (currentNumber) {
      this.codigoControl.setValue(currentNumber);
    }
  }

  saveReservaFx(): void {
    if (!isOrderEditable(this.data.service ?? {})) {
      this.toastr.warning(
        getOrderMutationBlockedMessage(
          'editar',
          this.data.service?.order?.orderStatus
        )
      );
      return;
    }

    this.loader = true;
    this.codigoControl.markAsTouched();

    if (this.codigoControl.invalid) {
      this.loader = false;
      return;
    }

    if (!this.orderId) {
      this.loader = false;
      this.toastr.error('El servicio no tiene una OS asociada.');
      return;
    }

    this.orderService
      .updateOrderReservationNumber({
        orderId: this.orderId,
        reservationNumber: this.codigoControl.value?.trim() || null,
      })
      .subscribe({
        next: (result) => {
          this.loader = false;
          this.dialogRef.close({
            success: true,
            shouldRefresh: false,
            order: result,
            orderNumber: result.orderNumber,
          });
        },
        error: (error: unknown) => {
          this.loader = false;
          const msg = resolveOrderGraphqlUserMessage(
            error,
            'No se pudo actualizar el número de reserva.'
          );

          if (shouldRefreshAfterOrderError(error)) {
            this.errorTitle = msg.title;
            this.errorMessage = formatUserMessageText(msg);
            this.state = 'error';
            this.dialogRef.disableClose = true;
            return;
          }

          this.toastr.error(msg.title, formatUserMessageText(msg));
        },
      });
  }

  cerrarYActualizar(): void {
    this.dialogRef.disableClose = false;
    this.dialogRef.close({
      success: false,
      shouldRefresh: true
    });
  }
}
